// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2lPue","vLegacy":"SelectSecondary_vLegacy__e-p8W","error":"SelectSecondary_error__1HiJM","disabled":"SelectSecondary_disabled__2BHl4"};